import { render, staticRenderFns } from "./createPrivacySetting.vue?vue&type=template&id=0ea4055a"
import script from "./createPrivacySetting.vue?vue&type=script&lang=js"
export * from "./createPrivacySetting.vue?vue&type=script&lang=js"
import style0 from "./createPrivacySetting.vue?vue&type=style&index=0&id=0ea4055a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports